import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import React from "react";
import { Player } from "../interfaces";
import X01Game from "./play/X01Game";

const PlayPage: React.FC = () => {
  type PlayTabs = "x01" | "cricket" | "bobs27";

  const [tab, setTab] = React.useState<PlayTabs>("x01");

  const PlayerOne: Player = {
    id: 1,
    name: "Andreas Buchmann",
    nickname: "Maxi",
    team: 1,
    is_captain: false,
  };
  const PlayerTwo: Player = {
    id: 2,
    name: "Max Mueller",
    nickname: "Maxi",
    team: 2,
    is_captain: false,
  };

  return (
    <Box>
      <Tabs
        value={tab}
        onChange={(_e, newValue) => setTab(newValue)}
        centered
        sx={{ mb: 3 }}
      >
        <Tab label="X01" value="x01" />
        <Tab label="Cricket" value="cricket" disabled />
        <Tab label="Bobs 27" value="bobs27" disabled />
      </Tabs>
      {/* Content for each tab can go here */}
      {tab === "x01" && <X01Game playerOne={PlayerOne} playerTwo={PlayerTwo} />}
      {tab === "cricket" && <Box>Cricket Spielmodus</Box>}
      {tab === "bobs27" && <Box>Bobs 27 Spielmodus</Box>}
    </Box>
  );
};

export default PlayPage;
